import { useScopedAppFlagStore } from '@frontend/scope';
import { autoRecallFeatureFlags } from '../../constants';

export const useIsAutoRecallAnalyticsDemoAccount = (): boolean => {
  // Maintaining a reusable hook to check if the account is a demo account
  // This hook will be updated further if we have more conditions to check
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isFFEnabled = getFeatureFlagValue(autoRecallFeatureFlags.autoRecallDemoData);

  return isFFEnabled;
};
